<template>
  <div>
    <div
      class="ma-3 rounded-xl myBlue2 myShadow"
      :width="$vuetify.breakpoint.xs ? 240 : 240"
      elevation="0"
    >
      <v-container class="d-flex justify-center pa-2">
        <v-card
          class="font-weight-bold text-h6 pa-0 myBlue2--text py-1 px-2 myYellow2"
        >
          {{ card.tableName }}
        </v-card>
      </v-container>

      <v-card
        class="d-flex pa-2 transparent"
        elevation="0"
        :width="$vuetify.breakpoint.xs ? 240 : 240"
      >
        <v-container class="pa-0 ma-0">
          <v-card
            class="text-center text-body-1 myBlue--text myYellow3 font-weight-bold"
            v-if="card.status == 'waiting for payment'"
          >
            Waiting for Payment
          </v-card>
          <v-card
            class="text-center text-body-1 white--text myGreen3 font-weight-bold"
            v-if="card.status == 'order processing'"
          >
            Order Processing
          </v-card>

          <div
            class="text-center text-h4 myYellow2--text font-weight-bold mt-2"
          >
            <v-icon large class="mb-1" color="myYellow2">mdi-account</v-icon>
            {{ card.customer_name }}
          </div>

          <div class="d-flex justify-space-between px-4 py-2 myYellow2--text">
            <div class="text-h6 font-weight-bold">
              <v-icon class="mb-1" color="myYellow2">mdi-cash-multiple</v-icon>
              {{ paymentMethod(card.payment_type) }}
            </div>
            <div class="text-h6 font-weight-bold">
              <v-icon class="mb-1" color="myYellow2"
                >mdi-clock-time-four-outline</v-icon
              >
              {{ card.date_order }}
            </div>
          </div>
        </v-container>
      </v-card>

      <v-container class="pa-3 text-center pb-6">
        <v-btn
          class="myHover"
          color="myYellow2 myBlue2--text font-weight-black"
          elevation="8"
          small
          :to="'/detail/' + card.id"
        >
          Order Details
        </v-btn>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  props: ["card"],
  methods: {
    paymentMethod(payload) {
      if (payload == "Bank Transfer") {
        return "BCA";
      } else {
        return payload;
      }
    },
  },
};
</script>
<style scoped>
  .myShadow{
    box-shadow: 0 0 40px 0px rgba(50, 121, 143, 0.8);
  }
</style>